import HeaderProgress from "@components/Progress/HeaderProgress";
import React from "react";
import { ReactComponent as PennyIcon } from "@assets/icons/penny_icon.svg";
import { useNavigate } from "react-router-dom";
import FactFindWelcomeIllustration from "@assets/illustrations/fact_find_welcome.png";
import FactFindWelcomeMobileIllustration from "@assets/illustrations/fact_find_welcome_m.png";
import BottomBarDesktop from "@components/BottomBars/BottomBarDesktop";
import BottomBar from "@components/BottomBars/BottomBar";
import ImageWithFallback from "@components/Image/ImageWithFallback";

type FactFindWelcomeProps = {};

const FactFindWelcome: React.FC<FactFindWelcomeProps> = () => {
  const navigate = useNavigate();

  return (
    <section className="grow flex items-start md:items-center justify-center border-t-4 border-l-0 md:border-t-0 md:border-l-4 border-[#F4E34E] px-0 md:px-2 lg:px-0">
      <div className="max-w-full md:max-w-[846px] w-full md:rounded-3xl md:border md:border-pn_gray-200">
        <HeaderProgress closeButtonEvent={() => navigate("/")} showOnlyClose />

        <div className="flex items-start flex-col-reverse md:flex-row">
          <div className="flex-1 pt-0 pb-0 pl-0 pr-0 md:pt-6 md:pb-6 md:pl-6 md:pr-8">
            <div className="p-4 flex flex-col gap-y-6">
              <div className="bg-[#F4E34E] rounded-full w-[60px] h-[60px] flex items-center justify-center">
                <PennyIcon className="w-[24px] h-[27px]" />
              </div>

              <div className="flex flex-col gap-y-1">
                <span className="text-pn-large-title text-pn_gray-950">
                  Welcome to Penny!
                </span>
                <span className="text-pn-headline-regular md:text-pn-body-large-regular text-pn_gray-600">
                  Your freedom fund starts here! <br /> Let's get started with a
                  few eligibility details.
                </span>
              </div>
            </div>
          </div>

          <div className="md:flex-1 w-full flex-initial pt-4 md:pt-6 pb-4 md:pb-6 pr-4 md:pr-6 pl-4 md:pl-8">
            <ImageWithFallback
              src={FactFindWelcomeIllustration || "/placeholder.svg"}
              alt="Fact Find Welcome"
              className="rounded-2xl object-cover w-full hidden md:block h-full"
              loading="eager"
              width="100%"
              height="auto"
            />
            <ImageWithFallback
              src={FactFindWelcomeMobileIllustration || "/placeholder.svg"}
              alt="Fact Find Welcome"
              className="rounded-2xl object-cover w-full block md:hidden h-full"
              loading="eager"
              width="100%"
              height="auto"
            />
          </div>
        </div>

        <div className="hidden md:block">
          <BottomBarDesktop
            onNext={() => navigate("/fact-find")}
            onBack={() => navigate("/")}
            labelBack="Go to Dashboard"
            labelNext="Eligibility Quiz"
            insideCard
          />
        </div>

        <div className="block md:hidden px-4 pb-6 pt-2">
          <BottomBar
            bordered={false}
            padding={false}
            onNext={() => navigate("/fact-find")}
            onBack={() => navigate("/")}
            layout="stacked_back"
            labelBack="Go to Dashboard"
            labelNext="Eligibility Quiz"
          />
        </div>
      </div>
    </section>
  );
};
export default FactFindWelcome;
